// extracted by mini-css-extract-plugin
export default {"section":"kIhcfFHk","container":"B3h1u1J2","grid":"GaeUqQTw","content":"bJ8E0uoV","title":"ZTWZkCna","text":"C7_B6Ft1","imageWrapper":"ZbsIR5LF","image":"lAsZkbwS"};